var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "52.75,59.61 7.25,59.61 7.25,30.34 10.23,30.34 10.23,56.64 49.77,56.64 49.77,30.34 52.75,30.34 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.82,29.12L33.5,4.8c-1.93-1.93-5.07-1.93-7,0L2.18,29.12l-2.1-2.1L24.4,2.7c3.09-3.09,8.12-3.09,11.21,0 l24.32,24.32L57.82,29.12z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.0a36a6e5d8dc1e036912051b438cfd04.svg";
export { ForwardRef as ReactComponent };